import { Button, MenuItem } from "@mui/material";
import { usePath } from "../libs/path/PathProvider";
import PortUtils from "../portlibs/PortUtils";
import React, { useState } from "react";
import MenuButton, { TopRightAnchor } from "../libs/button/MenuButton";
import { Add, ImportExport } from "@mui/icons-material";
import Utils from "../libs/Utils";
import usePortfolio from "../hooks/PortfolioProvider";
import { OpenAddHolding } from "../dialogs/AddHolding";
import ToggleMenuItem from "../libs/menu/ToggleMenuItem";
import MoveVert from "../libs/icons/MoveVert";

export default function TableShowFilter(){
    const {query, setQuery} = usePath()
    const {currency,showDisposed,convert} = PortUtils.getFilter(query)
    const {portfolio} = usePortfolio()
    const [open,setOpen] = useState<boolean>(false)
    const editHolding = OpenAddHolding()
    
    const onCAD = () => {
        if (currency==-2) setQuery({currency:0})
        else if (currency==-1) setQuery({currency:1})
        else if (currency==1) setQuery({currency:-1})
        else setQuery({currency:-2})
    }
    const onUSD = () => {
        if (currency==-2) setQuery({currency:1})
        else if (currency==-1) setQuery({currency:0})
        else if (currency==0) setQuery({currency:-1})
        else setQuery({currency:-2})
    }
    const onDisposed = () => setQuery({show:!showDisposed ? "1" : "0"})
    const onConvert = () => setQuery({convert:!convert ? "1" : "0"})
    const onAdd = () => { editHolding(null, null); setOpen(false) }
    const onExport = () => {
        Utils.exportFile(new Blob([JSON.stringify(portfolio.json)], {type:"text/json;charset=utf-8"}), `${portfolio.userId}.json`)
        setOpen(false)
    }
    const onToggle = (e:any,open:boolean) => setOpen(open)
    const options = [
        {value:"cad",element:<ToggleMenuItem onClick={onCAD} checked={currency==-1 || currency==0} text="CAD Assets"/>},
        {value:"usd",element:<ToggleMenuItem onClick={onUSD} checked={currency==-1 || currency==1} text="US Assets"/>},
        {value:"disposed",element:<ToggleMenuItem onClick={onDisposed} checked={showDisposed} text="Show closed"/>},
        {value:"convert",element:<ToggleMenuItem onClick={onConvert} checked={convert} text="Show in C$"/>},
        {value:"add",element:<MenuItem onClick={onAdd}><Button variant="text" startIcon={<Add/>}>Add holding</Button></MenuItem>},
        {value:"export",element:<MenuItem onClick={onExport}><Button variant="text" startIcon={<ImportExport/>}>Export</Button></MenuItem>}
    ]
    return <MenuButton menuProps={ {options,...TopRightAnchor} } open={open} onToggle={onToggle}><MoveVert/></MenuButton>
}